export default "__VITE_ASSET__CVgeGo_Z__"